<template>
  <div>
    <ProgressLoader
      v-if="loading"
      mode="indeterminate"
      color="#5AC396"
      size="150px"
    />

    <div v-else>
      <AuBreadcrumb :pages="breadcrumb" />
      <div class="card dao">
        <div class="title">
          {{ token?.nameEng }}
        </div>
        <div class="info">
          <div>
            <img
              class="icon"
              :src="tokenLogo"
              alt=""
            >
            <img
              class="round"
              src="../assets/img/green_icon.svg"
              alt=""
            >
          </div>
          <div class="indicators">
            <span class="value">
              {{ tokenAvailible }}
            </span>
            <span class="sign">
              {{ $t("daoTokens.amountDaoPortfolio") }}
            </span>
          </div>
        </div>
        <div class="buttons">
          <AuButton
            :type="switcher === 1 ? 'primary' : ''"
            @click="switcher = 1"
          >
            {{ $t("daoTokens.communityProjects") }}
          </AuButton>
          <AuButton
            :type="switcher === 2 ? 'primary' : ''"
            @click="switcher = 2"
          >
            {{ $t("daoTokens.archiveDao") }}
          </AuButton>
          <AuButton
            :type="switcher === 3 ? 'primary' : ''"
            @click="switcher = 3"
          >
            {{ $t("daoTokens.futureEvent") }}
          </AuButton>
        </div>
        <div v-if="switcher === 1">
          <AuNoData
            v-if="daoRequests?.length === 0"
            :text="$t('daoTokens.noData')"
          />
          <div v-else>
            <div class="voting-header">
              <span>
                {{ $t("daoTokens.voteEndDate") }}
              </span>
              <span>
                {{ $t("daoTokens.voteName") }}
              </span>
              <span>
                {{ $t("daoTokens.voteDescription") }}
              </span>
            </div>
            <div
              v-for="(daoRequest, index) in daoRequests"
              :key="index"
            >
              <ProjectSurvey
                v-if="daoRequest.result.length <= 2"
                :id="daoRequest.id"
                :dao-request="daoRequest"
                :owner-amount="ownerAmount"
                :user-data="userData"
                @newDaoRequest="getDao"
              />
              <ProjectSurveyMany
                v-else
                :id="daoRequest.id"
                :dao-request="daoRequest"
                :owner-amount="ownerAmount"
                :user-data="userData"
                @newDaoRequest="getDao"
              />
            </div>
          </div>
        </div>
        <div v-show="switcher === 2">
          <AuNoData
            v-if="daoRequestsArchive?.length === 0"
            :text="$t('daoTokens.noData')"
          />
          <div v-else>
            <div class="voting-header">
              <span>
                {{ $t("daoTokens.voteEndDate") }}
              </span>
              <span>
                {{ $t("daoTokens.voteDescription") }}
              </span>
              <span>
                {{ $t("daoTokens.survey.results") }}
              </span>
            </div>
            <ProjectSurveyArchive
              v-for="(daoRequest, index) in daoRequestsArchive"
              :id="daoRequest.id"
              :key="index"
              :dao-request="daoRequest"
              :project-id="clearId"
            />
          </div>
        </div>
        <div v-if="switcher === 3">
          <AuNoData
            v-if="items?.length === 0"
            :text="$t('daoTokens.noData')"
          />
          <div v-else>
            <AuTable
              :columns="columns"
              :items="items"
              :loading="soonLoading"
            />
            <AuPagination
              v-if="daoSoonTotal > soonItemsPerPage"
              :total-items="daoSoonTotal"
              @pageChanged="soonPageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import BigNumber from "bignumber.js";
import CurrencySupport from "@/help/currencySupport";
import moment from "moment";
import ProgressLoader from "@/loaders/progress-bar";
import ProjectSurvey from "../components/ProjectSurvey.vue";
import ProjectSurveyArchive from "../components/ProjectSurveyArchive.vue";
import ProjectSurveyMany from "../components/ProjectSurveyMany.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ProgressLoader,
    ProjectSurvey,
    ProjectSurveyArchive,
    ProjectSurveyMany
  },
  props: {
    id: {
      type: String,
      default: "0"
    }
  },

  data() {
    return {
      switcher: 1,
      currencySup: new CurrencySupport(),
      daoRequestsArchive: [],
      daoRequestsArchiveTotal: 0,
      daoSoon: [],
      daoSoonTotal: null,
      soonPage: 1,
      soonItemsPerPage: 20,
      soonLoading: false,
      capital: {},
      tokenId: null,
      loading: true
    };
  },

  computed: {
    ...mapGetters({
      tokens: "tokens",
      auOwners: "auOwners",
      userData: "ethAddresses",
      defaultTokenMnemonic: "defaultToken/defaultTokenMnemonic",
      daoRequests: "dao/daoRequests",
      daoRequestsTotal: "dao/daoRequestsTotal",
      token: "dao/token"
    }),

    clearId() {
      return this.id.replace(/\D/g, "");
    },

    clearHash() {
      return window.location.hash.replace(/\D/g, "");
    },

    columns() {
      return [
        { name: this.$t("daoTokens.dateStart"), align: "left" },
        { name: this.$t("daoTokens.name"), align: "left" },
        { name: this.$t("daoTokens.description"), align: "left" }
      ];
    },

    tokenLogo() {
      return (
        this.capital?.logoMain ??
        this.capital?.mainImage?.name ??
        "/svg/companies/s_logo.svg"
      );
    },

    tokenAvailible() {
      return this.ownerAmount + " " + this.token.mnemonicEng;
    },

    ownerAmount() {
      const ret = _.find(
        this.auOwners,
        (owner) => owner.auToken.id == this.tokenId
      );
      return (
        BigNumber(_.get(ret, "amount", 0))
          .div(BigNumber(10).pow(this.token?.decimals))
          .toString(10)
      );
    },

    items() {
      return _.map(this.daoSoon, (item) => ({
        startAt: moment(item.startAt).format("DD.MM.YYYY"),
        name: item.name,
        description: item.description
      }));
    },

    breadcrumb() {
      const breadcrumb = [
        { key: 0, name: this.$t("router.pages.project"), path: "/my-projects" }
      ];
      if (this.capital?.tokenBase?.nameEng) {
        breadcrumb.push({
          key: breadcrumb?.length,
          name: this.capital?.tokenBase?.nameEng,
          path: `/project-card/${this.clearId}`
        });
      }
      return breadcrumb;
    }
  },

  watch: {
    switcher() {
      this.updateRoute();
    }
  },

  async mounted() {
    if (_.isEmpty(this.auOwners)) {
      await this.getAuOwners();
    }
    this.capital = await this.getAuCapitals(this.clearId);
    this.tokenId = this.capital?.tokenBase?.id;
    await this.getToken(this.tokenId);
    await this.getDaoSoon();
    await this.getDao();
    this.loading = false;
    this.checkHash();

    const tab = this.$route.query.tab;
    if (tab === "archive") {
      this.switcher = 2;
    }
    else if (tab === "future") {
      this.switcher = 3;
    }

    this.loading = false;
    this.checkHash();
  },

  methods: {
    ...mapActions({
      getDaoRequests: "dao/getDaoRequests",
      getToken: "dao/getToken",
      getAuCapitals: "capitals/getAuCapitals",
      getAuOwners: "getAuOwners"
    }),

    updateRoute() {
      let query = {};
      if (this.switcher === 2) {
        query.tab = "archive";
      }
      else if (this.switcher === 3) {
        query.tab = "future";
      }

      this.$router.replace({
        query: Object.keys(query).length ? query : undefined
      });
    },

    async getDao() {
      await this.getDaoRequests({
        page: 1,
        itemsPerPage: 20,
        status: "closed",
        tokenDaoId: this.tokenId
      });
      this.daoRequestsArchive = _.cloneDeep(this.daoRequests);
      this.daoRequestsArchiveTotal = this.daoRequestsTotal;
      const params = {
        page: 1,
        itemsPerPage: 20,
        tokenDaoId: this.tokenId
      };
      await this.getDaoRequests(params);
    },

    async getDaoSoon() {
      this.soonLoading = true;
      await this.getDaoRequests({
        page: this.soonPage,
        itemsPerPage: this.soonItemsPerPage,
        tokenDaoId: this.tokenId,
        status: "draft"
      });
      this.daoSoon = _.cloneDeep(this.daoRequests);
      this.daoSoonTotal = this.daoRequestsTotal;
      this.soonLoading = false;
    },

    async soonPageChange(page) {
      this.soonPage = page;
      await this.getDaoSoon();
    },

    checkHash() {
      if (!window.location.hash) {
        return;
      }
      if (_.findIndex(this.daoRequestsArchive, dao => dao.id == this.clearHash) !== -1) {
        this.switcher = 2;
      }
      setTimeout(() => {
        const element = document.getElementById(this.clearHash);
        if (element) {
          element.scrollIntoView({ block: "end" });
        }
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.dao {
  padding: 20px;

  .title {
    font-size: 24px;
    color: var(--text-color);
    line-height: 1.1;
  }

  .info {
    display: flex;
    gap: 10px;
    padding: 30px 0;
    border-bottom: 1px dashed var(--color-50);
    margin-bottom: 30px;
  }

  .icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
  }

  .round {
    width: 12px;
    height: 12px;
    position: relative;
    top: -20px;
  }

  .indicators {
    display: flex;
    flex-direction: column;

    .value {
      font-weight: 500;
      font-size: 16px;
    }

    .sign {
      color: var(--color-50);
      font-weight: 500;
      font-size: 12px;
    }
  }

  .buttons {
    display: flex;
    gap: 10px;
    margin-bottom: 30px;
  }

  .voting-header {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    padding: 15px 5px 18px 5px;
    border-bottom: 1px solid var(--border-color);
    border-top: 1px solid var(--border-color);
    span {
      font-size: 12px;
      color: var(--color-20);
    }
  }
}
</style>
